<template>
  <page>
    <div>
      <v-card>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12>
                <form ref="TXTForm1">
                  <input type="file" style="display: none" ref="TXTfile1" :accept="'.txt' || '.TXT'" @change="doValidateFile1" />
                </form>
                <v-text-field
                  readonly
                  v-model="form.requestedFile1"
                  :label="labels.requestedFile1"
                  :error-messages="errors.collect('requestedFile1')"
                  data-vv-name="requestedFile1"
                  :data-vv-as="labels.requestedFile1"
                  append-icon="mdi-magnify"
                  @click:append="pickFile1"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <form ref="TXTForm2">
                  <input type="file" style="display: none" ref="TXTfile2" :accept="'.txt' || '.TXT'" @change="doValidateFile2" />
                </form>
                <v-text-field
                  readonly
                  v-model="form.requestedFile2"
                  :label="labels.requestedFile2"
                  :error-messages="errors.collect('requestedFile2')"
                  data-vv-name="requestedFile2"
                  :data-vv-as="labels.requestedFile2"
                  append-icon="mdi-magnify"
                  @click:append="pickFile2"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
      <v-spacer class="mt-3"></v-spacer>
      <v-container fluid grid-list-lg>
        <v-btn color="primary" dark class=" mr-2" @click="doSend">
          <v-icon>mdi-upload</v-icon>
          Upload
        </v-btn>
      </v-container>
    </div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      uploading: false,
      labels: {
        requestedFile1: 'Upload File 1',
        requestedFile2: 'Upload File 2'
      },
      form: {
        requestedFile1: '',
        requestedFile2: ''
      },
      textDataTransferObject: []
    }
  },
  methods: {
    doValidateFile1(e) {
      this.form.requestedFile1 = ''
      this.resetMessages()
      if (e.target.files[0]) {
        this.uploading = true
        const file = e.target.files[0]
        if (file.name.indexOf('.txt') !== -1 || file.name.indexOf('.TXT') !== -1) {
          var filehead = file.name.substring(0, 6)
          if (filehead === 'UIPC02') {
            this.form.requestedFile1 = file.name
            const fileReader = new FileReader()
            fileReader.readAsText(file)
            fileReader.onload = async () => {
              var lines = fileReader.result.split('\n')
              let dataObj = []
              let headerRecord = []
              let detailRecord = []
              let trailerRecord = []
              if (lines.length > 1) {
                if (lines[0].substring(0, 1) === '1') {
                  headerRecord = lines[0]
                  trailerRecord = lines[lines.length - 1]
                  for (var i = 1; i < lines.length - 1; i++) {
                    detailRecord.push({
                      detailLine: lines[i]
                    })
                  }
                  dataObj = {
                    headerRecord: headerRecord,
                    detailRecord: detailRecord,
                    trailerRecord: trailerRecord
                  }
                  if (this.textDataTransferObject.length > 1) {
                    this.textDataTransferObject.splice(0, 1, dataObj)
                  } else {
                    this.textDataTransferObject.push({
                      headerRecord: headerRecord,
                      detailRecord: detailRecord,
                      trailerRecord: trailerRecord
                    })
                  }
                } else {
                  this.$toast.error('Upload unsuccessful - Invalid Record Header')
                  this.form.requestedFile1 = ''
                }
              } else {
                this.$toast.error('No Line Is Found On The Text File Uploaded')
              }
            }
          } else {
            this.$toast.error('Upload File 1 filename must starts with UIPC02')
          }
        } else {
          this.$toast.error('Please Select Text File (.txt) Only!')
        }
      }
      this.uploading = false
      this.doUpload(e)
    },
    doValidateFile2(e) {
      this.form.requestedFile2 = ''
      this.resetMessages()
      if (e.target.files[0]) {
        this.uploading = true
        const file = e.target.files[0]
        if (file.name.indexOf('.txt') !== -1 || file.name.indexOf('.TXT') !== -1) {
          var filehead = file.name.substring(0, 6)
          if (filehead === 'UIPC03') {
            this.form.requestedFile2 = file.name
            const fileReader = new FileReader()
            fileReader.readAsText(file)
            fileReader.onload = async () => {
              var lines = fileReader.result.split('\n')
              let dataObj = []
              let headerRecord = []
              let detailRecord = []
              let trailerRecord = []
              if (lines.length > 1) {
                if (lines[0].substring(0, 1) === '1') {
                  headerRecord = lines[0]
                  trailerRecord = lines[lines.length - 1]
                  for (var i = 1; i < lines.length - 1; i++) {
                    detailRecord.push({
                      detailLine: lines[i]
                    })
                  }
                  dataObj = {
                    headerRecord: headerRecord,
                    detailRecord: detailRecord,
                    trailerRecord: trailerRecord
                  }
                  if (this.textDataTransferObject.length > 1) {
                    this.textDataTransferObject.splice(1, 1, dataObj)
                  } else {
                    this.textDataTransferObject.push({
                      headerRecord: headerRecord,
                      detailRecord: detailRecord,
                      trailerRecord: trailerRecord
                    })
                  }
                } else {
                  this.$toast.error('Upload unsuccessful - Invalid Record Header')
                  this.form.requestedFile2 = ''
                }
              } else {
                this.$toast.error('No Line Is Found On The Text File Uploaded')
              }
            }
          } else {
            this.$toast.error('Upload File 2 filename must starts with UIPC03')
          }
        } else {
          this.$toast.error('Please Select Text File (.txt) Only!')
        }
      }
      this.uploading = false
      this.doUpload(e)
    },
    pickFile1() {
      this.$refs.TXTForm1.reset()
      this.$refs.TXTfile1.click()
    },
    pickFile2() {
      this.$refs.TXTForm2.reset()
      this.$refs.TXTfile2.click()
    },
    async getFile(event) {
      this.file = event.target.files[0]
    },
    async doUpload(event) {
      await this.getFile(event)
    },
    async doSend() {
      const dto = []
      dto.push({
        dataUploaded: this.textDataTransferObject,
        format: 'PDF',
        sendEmail: false
      })
      const apiURI = this.$store.state.underwriting.specialFuncUWSettings.menu.uploadUOBProposal
      if (apiURI) {
        this.uploading = true
        try {
          if (this.textDataTransferObject[0].headerRecord.substring(4, 12) !== this.textDataTransferObject[1].headerRecord.substring(4, 12)) {
            this.$toast.error('Upload unsuccessful - Different Processing Date')
          } else {
            await this.$http.post(apiURI, dto[0])
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.uploading = false
      } else {
        this.$toast.error('Request Mapping Not Found!')
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit')
    }
  },
  mixins: [MessageMixin]
}
</script>
